import PropTypes from 'prop-types';
import { FaCopy } from 'react-icons/fa';

/**
 * Filter button component.
 * 
 * @param {object} props
 * @param {string} props.id - button ID
 * @param {Function} props.action - function to run when the button is clicked
 */
const DuplicateButton = ({ id, action }) => {
    return (
        <button id={id} onClick={action}>
            {<FaCopy />}
        </button>
    );
};

DuplicateButton.propTypes = {
    id: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
};


export default DuplicateButton;
